export const CALL_RECORDING_FILE = 'CallRecording';
export const CONVERGED_RECORDINGS = 'convergedRecordings';
export const SOFT_DELETE = 'softDelete';
export const METADATA = 'metadata';
export const FROM = 'from';
export const TO = 'to';
export const STATUS = 'status';
export const MAX = 'max';
export const SERVICE_TYPE = 'serviceType';
export const FORMAT = 'format';
export const OWNER_TYPE = 'ownerType';
export const STORAGE_REGION = 'storageRegion';
export const LOCATION_ID = 'locationId';
export const TOPIC = 'topic';
export const DEFAULT_STATUS = 'available';
export const DEFAULT_MAX = 30;
export const DEFAULT_NUMBER_OF_DAYS = 30;
export const WEBEX_USER_REQUEST_HEADER = 'WebexUserRequest';
export const RECORDING_NOT_FOUND_MESSAGE = 'No recordings found for the given call session id.';
export const METHODS = {
    INITIALIZE_BACKEND_CONNECTOR: 'initializeBackendConnector',
    GET_CALL_RECORDING: 'getCallRecording',
    GET_RECORDINGS: 'getRecordings',
    GET_RECORDING: 'getRecording',
    GET_RECORDINGS_BY_CALL_SESSION_ID: 'getRecordingsByCallSessionId',
    GET_RECORDING_METADATA: 'getRecordingMetadata',
    DELETE_RECORDING: 'deleteRecording',
};
